import { render, staticRenderFns } from "./Merchandise.vue?vue&type=template&id=6454c3c2"
import script from "./Merchandise.vue?vue&type=script&lang=js"
export * from "./Merchandise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports